// =====================================================================
// PLENARIUM:LIXEIRA -- exclusao de sessao/pauta com protecao
// excluirComConfirmacao(url): tenta excluir. Se o servidor recusar porque
// a sessao ja foi realizada (ou a pauta ja foi votada):
//  - admin da camara: abre a janela do PEDIDO DE EXCLUSAO (motivo) --
//    nada e apagado; o suporte (Super Admin) aprova ou recusa
//    (PLENARIUM:LIXEIRA_PEDIDOS);
//  - Super Admin: pede o motivo e exclui.
// Devolve true so quando excluiu; false se cancelou ou se virou pedido.
// Outros erros sao repassados (throw).
// =====================================================================
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import { AlertTriangle, X, Send, CheckCircle2 } from 'lucide-react';

function Janela({ aviso, modo, url, onFim }) {
  const pedido = modo === 'PEDIDO';
  const [motivo, setMotivo] = useState('');
  const [erro, setErro] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [enviado, setEnviado] = useState('');
  const enviar = async (e) => {
    e.preventDefault();
    if (motivo.trim().length < 10) { setErro('Escreva o motivo (pelo menos 10 letras).'); return; }
    setOcupado(true); setErro('');
    try {
      const r = await axios.delete(url, { data: { motivo: motivo.trim() } });
      if (r.status === 202 || (r.data && r.data.pedidoCriado)) { setEnviado((r.data && r.data.message) || 'Pedido enviado ao suporte.'); setOcupado(false); return; }
      onFim(true);
    } catch (er) { setErro((er.response && er.response.data && er.response.data.error) || 'Não foi possível concluir.'); setOcupado(false); }
  };
  if (enviado) {
    return (
      <div className="modal-overlay">
        <div className="modal" style={{ maxWidth: 480 }}>
          <div style={{ textAlign: 'center', padding: '10px 6px 4px' }}>
            <CheckCircle2 size={40} color="#16a34a" />
            <h2 className="modal-title" style={{ justifyContent: 'center', margin: '10px 0 8px' }}>Pedido enviado</h2>
            <p style={{ fontSize: '.86rem', lineHeight: 1.5, color: '#334155', margin: '0 0 16px' }}>{enviado}</p>
            <button type="button" className="btn btn-primary" onClick={() => onFim(false)}>Entendi</button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="modal-overlay" onClick={() => !ocupado && onFim(false)}>
      <div className="modal" style={{ maxWidth: 500 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title" style={{ color: pedido ? '#92400e' : '#b91c1c' }}><AlertTriangle size={17} /> {pedido ? 'Pedido de exclusão' : 'Confirmar exclusão'}</h2>
          <button type="button" className="btn-modal-close" onClick={() => !ocupado && onFim(false)}><X size={18} /></button>
        </div>
        <form onSubmit={enviar}>
          <p style={{ fontSize: '.86rem', lineHeight: 1.5, margin: '0 0 12px', color: '#334155' }}>{aviso}</p>
          <p style={{ fontSize: '.78rem', lineHeight: 1.5, margin: '0 0 14px', color: '#64748b' }}>{pedido
            ? 'Para proteger o histórico da Câmara, o que já foi realizado ou já tramitou (sessão realizada, pauta votada, matéria ou protocolo já movimentado) só é excluído pelo suporte. Seu pedido fica registrado com seu nome, o motivo e o horário. Nada é apagado até a aprovação.'
            : 'A exclusão fica registrada com seu nome, o motivo e o horário. Uma cópia fica na lixeira por 90 dias.'}</p>
          <div className="form-group">
            <label className="form-label">Motivo da exclusão *</label>
            <textarea className="form-input" rows={3} value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Ex.: cadastrado em duplicidade" /* PLENARIUM:LIXEIRA_MATERIAS */ style={{ resize: 'vertical' }} autoFocus />
          </div>
          {erro && <p style={{ color: '#b91c1c', fontSize: '.82rem', fontWeight: 600, margin: '0 0 10px' }}>{erro}</p>}
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" disabled={ocupado} onClick={() => onFim(false)}>Cancelar</button>
            {pedido
              ? <button type="submit" className="btn btn-warning" disabled={ocupado}><Send size={14} /> {ocupado ? 'Enviando...' : 'Enviar pedido ao suporte'}</button>
              : <button type="submit" className="btn btn-danger" disabled={ocupado}>{ocupado ? 'Excluindo...' : 'Excluir'}</button>}
          </div>
        </form>
      </div>
    </div>
  );
}

function abrir(aviso, modo, url) {
  return new Promise((resolve) => {
    const div = document.createElement('div'); document.body.appendChild(div);
    const root = createRoot(div);
    const fim = (ok) => { setTimeout(() => { root.unmount(); div.remove(); }, 0); resolve(ok); };
    root.render(<Janela aviso={aviso} modo={modo} url={url} onFim={fim} />);
  });
}

function avisoSimples(texto) {
  return new Promise((resolve) => {
    const div = document.createElement('div'); document.body.appendChild(div);
    const root = createRoot(div);
    const fim = () => { setTimeout(() => { root.unmount(); div.remove(); }, 0); resolve(false); };
    root.render(
      <div className="modal-overlay" onClick={fim}>
        <div className="modal" style={{ maxWidth: 460 }} onClick={e => e.stopPropagation()}>
          <p style={{ fontSize: '.88rem', lineHeight: 1.5, color: '#334155', margin: '4px 0 16px' }}>{texto}</p>
          <div className="modal-actions"><button type="button" className="btn btn-primary" onClick={fim}>Entendi</button></div>
        </div>
      </div>
    );
  });
}

export async function excluirComConfirmacao(url) {
  try {
    const r = await axios.delete(url);
    if (r.status === 202) return avisoSimples((r.data && r.data.message) || 'Pedido enviado ao suporte.');
    return true;
  } catch (err) {
    const d = err.response && err.response.data;
    if (err.response && err.response.status === 409 && d && d.pedidoPendente) return avisoSimples(d.error);
    if (err.response && err.response.status === 409 && d && (d.exigeConfirmacao || d.exigeSenha)) return abrir(d.error || 'Esta exclusão precisa de confirmação.', d.modo || 'PEDIDO', url);
    throw err;
  }
}
